export function formatCoins(amount) {
    return `${amount.toLocaleString()} coin${amount === 1 ? '' : 's'}`;
}
export function formatUsdCents(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}
export function formatUsername(username) {
    return `@${username}`;
}
export function formatActorName(input) {
    if (input.displayName && input.displayName.trim().length > 0) {
        return input.displayName.trim();
    }
    if (input.username) {
        return formatUsername(input.username);
    }
    return input.email;
}
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function isUuid(value) {
    return UUID_PATTERN.test(value);
}
export function normalizeUsernameParam(value) {
    const trimmed = value.trim();
    return trimmed.startsWith('@') ? trimmed.slice(1) : trimmed;
}
export function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}
/**
 * Turn a title into a URL-safe slug: lowercase, ASCII-ish, hyphen-separated.
 * Falls back to `item` when nothing usable remains, so a URL never collapses.
 */
export function slugify(value) {
    const base = value
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80)
        .replace(/-+$/g, '');
    return base.length > 0 ? base : 'item';
}
export { canTransitionShow, FAN_INITIATED_SHOW_TYPES, FAN_PRIVATE_QUEUE_TYPES, isFanInitiatedShowType, isPrivateQueueJoinable, isPrivateQueueAvailable, isPublicMainStage, isShowOnBreak, listModelTransitionTargets, listTransitionTargets, MODEL_START_SHOW_TYPES, TICKET_DURATION_OPTIONS, } from './showTypes.js';
export { formatTipChatBody, parseTipChatBody } from './tip-chat.js';
export { computePrivateQueueEstimate, formatPrivateDiscountLabel, formatPrivateDurationLabel, } from './privatePricing.js';
export { CPM_COUNTDOWN_MS, CPM_HOLD_MS, CPM_WARN_MS, estimateCpmRemainingMs, formatCpmCountdown, holdRemainingMs, resolveCpmRunwayPhase, } from './cpm-runway.js';
//# sourceMappingURL=index.js.map